import React from 'react';
import { Alert } from "@mui/lab";

type RateCardAlertProps = {
  contractCreated: string;
  includeRateCard: boolean;
};

const RateCardAlert = ({ contractCreated, includeRateCard}: RateCardAlertProps) => {
  const contractCreatedYear = new Date(contractCreated).getFullYear();
  const currentYear = new Date().getFullYear();
  const shouldShowRateCardAlert = includeRateCard && contractCreatedYear !== currentYear;

  return shouldShowRateCardAlert ? (
    <Alert severity="warning">
      The rate card in the contract is from {currentYear}, but the contract was originally created
      in {contractCreatedYear}. Updating the contract will also change the rate card. Disable & manually
      include a rate card, if you don't want the rate card to change.
    </Alert>) : null
};

export default RateCardAlert;
